import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
declare var webkitSpeechRecognition:any
@Injectable({
  providedIn: 'root'
})
export class VoiceRecognitionService {
  recognition =  new webkitSpeechRecognition();
  isStoppedSpeechRecog = false;
  public text = '';
  speechToText: BehaviorSubject<string> = new BehaviorSubject('');
  speechToText$ = this.speechToText.asObservable();
  tempWords!: string;
 
  constructor() { }
 
  init() {
    this.recognition.interimResults = true;
    this.recognition.lang = 'en-ZA';
    this.text = '';
    this.speechToText.next('');
    this.recognition.addEventListener('result', (e: { results: Iterable<unknown> | ArrayLike<unknown>; }) => {
      const transcript = Array.from(e.results)
        .map((result) => result[0])
        .map((result) => result.transcript)
        .join('');
      this.tempWords = transcript;
    });
  }
 
  start() {
    this.isStoppedSpeechRecog = false;
    this.recognition.start();
    console.log("Speech recognition started")
    this.recognition.addEventListener('end', () => {
      if (this.isStoppedSpeechRecog) {
        this.recognition.stop();
        console.log("End speech recognition")
      } else {
        this.wordConcat()
        this.recognition.start();
      }
    });
  }
  stop() {
    this.isStoppedSpeechRecog = true;
    this.wordConcat()
    this.recognition.stop();
    console.log("End speech recognition")
  }
 
  wordConcat() {
    if(this.tempWords && this.tempWords.length > 1){
      this.text = this.text + ' ' + this.tempWords + '.';
      this.speechToText.next(this.text);
    }
    this.tempWords = '';
  }
}
